<!-- =========================================================================================
  File Name: ResourceCreate.vue
  Description: Resource Create Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-edit">
		<bread-crumbs
			:title="$t('CreateResource')"
			:subTitle="$t('general.SubTitleResource')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		>
		</bread-crumbs>
		<div slot="no-body" class="tabs-container">
			<resource-create-tab-account
				v-if="
					resourceCreatePermission &&
					objectRPermission &&
					typeConfigRPermission &&
					statusRPermission &&
					roleRPermission
				"
				:roles="roles"
				:resource_data="resourceData"
				:manual_data_id="manualDataId"
				:upload_file_id="uploadFileId"
			/>
			<not-permission v-else :message="message"></not-permission>
		</div>
	</div>
</template>

<script>
import ResourceCreateTabAccount from "./ResourceCreateTabAccount.vue";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	components: {
		ResourceCreateTabAccount,
		NotPermission,
	},
	data() {
		return {
			activeTab: 0,
			resourceData: null,
			manualDataId: 0,
			uploadFileId: 0,
		};
	},
	computed: {
		roles() {
			return this.$store.state.moduleRoles.roles.filter((r) => r.name !== "GOTU");
		},
		resourceCreatePermission() {
			return this.$store.getters.checkPermission("RESOURCES_C");
		},
		objectRPermission() {
			return this.$store.getters.checkPermission("OBJECTS_R");
		},
		typeConfigRPermission() {
			return this.$store.getters.checkPermission("TYPE_CONFIG_R");
		},
		roleRPermission() {
			return this.$store.getters.checkPermission("ROLE_R");
		},
		statusRPermission() {
			return this.$store.getters.checkPermission("STATUS_R");
		},
		message() {
			return `${this.$t(
				"Permissions.RequiredPermissions"
			)} "RESOURCES_C" , "ROLE_R", "STATUS_R", "OBJECTS_R", "TYPE_CONFIG_R"`;
		},
	},
	methods: {
		getRoles() {
			this.$store.dispatch("moduleRoles/getRoles").then((res) => {});
		},
	},
	created() {
		// Consultar roles
		if (this.$store.state.moduleRoles.roles.length <= 0) this.getRoles();
		const resource_data = this.$route.params.resource_data;
		const manual_data_id = this.$route.params.manual_data_id;
		const upload_file_id = this.$route.params.upload_file_id;
		if (resource_data) {
			this.resourceData = resource_data;
			this.manualDataId = manual_data_id;
			this.uploadFileId = upload_file_id;
		}
	},
};
</script>
